import React, { FC } from 'react'
import { Avatar as AntAvatar, AvatarProps as AntAvatarProps } from 'antd'
import {
    getAvatarColorFromUsername,
    getInitials,
} from 'store/authStore/authStore'

interface AvatarProps extends AntAvatarProps {
    login: string
}

const Avatar: FC<AvatarProps> = ({ login, ...props }) => {
    return (
        <AntAvatar
            {...props}
            style={{
                color: 'white',
                backgroundColor: getAvatarColorFromUsername(login),
                ...props.style,
            }}
            alt="login"
        >
            {getInitials(login)}
        </AntAvatar>
    )
}

export default Avatar
